<template>
    <div>
        <div>
        
     <v-layout class = "mr-5 mt-4">

       <h2 style="margin-left:15px; margin-top :20px;font-family:Verdana;font-size:16px"> <v-icon>mdi-car-multiple</v-icon> Cars Types List</h2>
        <v-spacer></v-spacer>
        
       <v-btn @click = "openDialog()" rounded  outlined> Add New Car Type </v-btn>
     </v-layout>
   </div>
   <v-container fluid>
     <v-card>
       <!-- <v-btn @click="selectAll()">try </v-btn> -->
            <v-container fluid>
        <v-simple-table fixed-header dense>
        <thead>
            <tr>
                <!-- <th class="text-center" style = "color:black;font-family:Verdana" >Car Type ID </th> -->
                <th class="text-center" style = "color:black;font-family:Verdana"> Car Type </th>
                <th class="text-center" style = "color:black;font-family:Verdana"> Capacity </th>
                 <th class="text-center" style = "color:black;font-family:Verdana"> Details </th>
                
            </tr>
            </thead>
            <tbody>
               <tr v-for="item in cartypeList" :key="item.id">

            <!-- <td class="text-center" style = "color:black;font-family:Verdana">{{item.id}}</td>         -->
          <td class="text-center" style = "color:black;font-family:Verdana">{{ item.cartype }}</td>
          <td class="text-center" style = "color:black;font-family:Verdana">{{ item.capacity }}</td>
   
                 <td class="text-center" style = "color:black;font-family:Verdana">
                     <v-btn @click="editRec(item)" elevation="0" small fab>
                        <v-icon color="grey darken-1">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn @click="deleteRec(item,item.id)" elevation="0" small fab>
                        <v-icon color="grey darken-1">mdi-trash-can-outline</v-icon>
                    </v-btn>

                 </td>
                
                
                
                    
               </tr>
               
            </tbody>
                  
                
              
            </v-simple-table>
     
        </v-container>
        </v-card>
     </v-container>

     <v-dialog v-model = "dialog" persistent width="350px">
      <v-card>
          <v-toolbar dense color="#213c57" dark>
           <span style = "font-family: Verdana;font-size:15px"> Car Type Information</span>
            <v-spacer></v-spacer>
             <v-btn icon @click = "dialog = !dialog"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-layout row>
                <v-row>
                    <v-col>
                   <!-- <v-text-field readonly outlined label = "Type ID" dense></v-text-field> -->
                   <v-text-field v-model="toAdd.cartype" outlined label = "Car Type" dense></v-text-field>
               
                   
                 <v-text-field v-model="toAdd.capacity" outlined label = "Capacity" dense type="number"></v-text-field>
         
           
                  
                </v-col>
                </v-row>
              </v-layout>
            <v-layout>
            <v-spacer></v-spacer>

              <v-btn @click = "addCartypelist()"> {{btnName}} </v-btn>
            </v-layout>
            </v-container>
          </v-card-text>
      </v-card>
     </v-dialog>
    </div>
</template>

<script>
// import axios from 'axios'
import api from '../api.js'
import swal from 'sweetalert'
import _ from 'lodash'
export default {
    components:{
     
    },
    created(){
         this.loadcartypelist()
    },
    data(){
        return{
        dialog: false,
        cartypeList:[],
        toAdd:{},
        btnName:'',
        list1:[],
        exam : '',
        arr : []

        }
    },
    methods: {
      openDialog(){
         this.dialog = true
         this.btnName = 'Save'
       },
       addCartypelist(){
            if (this.btnName == 'Save'){
               swal( "New Car type Added", " " , "success" , {
                timer: 1000,
                button:false
               })
                let url = `${this.api}addcartype`
                api.post(url, this.toAdd).then (res =>{
                // this.employeedata = res.data
                console.log(res.data)
                this.loadcartypelist()
                this.dialog = false
                this.toAdd = {}
    
                } ) 
            } 
            else if (this.btnName == 'Update'){
                 swal( "Car type has been updated", " " , "success" , {
                timer: 1000,
                button:false
               })
                let url1 = `${this.api}updatecarType`
                api.put(url1,this.toAdd).then (res =>{
                console.log(res.data)

                
                this.loadcartypelist()
                this.dialog = false
                this.toAdd ={}
                })

            }

       },
       loadcartypelist(){
          let url =  `${this.api}cartypelist`
         api.get(url).then( res => {
        this.cartypeList = _.orderBy(res.data, ['cartype'], ['ASC']).filter(r =>{
             return r.id !== '000001'
           })
      //  console.log(this.employeedata)
      }) 
       },
       editRec(rec){
           
          this.dialog = true
          this.btnName = 'Update'
         this.toAdd.id = rec.id
          this.toAdd.cartype = rec.cartype
          this.toAdd.capacity = rec.capacity  
      },

      deleteRec(rec,id) {
        swal({
          title: 'Do you want to delete this car type?',
          icon : 'warning',
          closeOnEsc: false,
          closeOnClickOutside: false,
          buttons : [ 'No',  'Yes']
            
          }).then( (willApprove)=>{
             if (willApprove) {
               swal( "Car type has been deleted", " " , "error" , {
                timer: 1000,
                button:false
               })
             const index = this.cartypeList.indexOf(rec)
         
           this.cartypeList.splice(index,1)
              let url = `${this.api}deletecarType`
              api.post(url,{id:id}).then( res => {
              console.log(res.data)
              this.loadcartypelist()
              })
             }
          })

      
        
      },

      selectAll(){
        for (let item in this.cartypeList){
          let index = this.cartypeList.indexOf(item.id)
          this.list1.push(index)
          
        }
        console.log(this.list1)
      },

     
    }
}
</script>



